/* Style - Statics */
import "./Uploader.css";
import "react-dropzone-uploader/dist/styles.css";
import LoadingGif from "./../../../static/loader.gif";
/* Libs */
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone-uploader";
/* Components */
import ModalAlert from "../Modal/modalAlert";
/* Controllers - Helpers */
import { getExtensionVideoFile } from "../../../helpers/getExtensionVideoFile";
import { presignedURL } from "../../../controllers/presignedURL";
import { uploadImage } from "../../../controllers/uploadImage";
import { signIn } from "../../../controllers/basicAuthlbda";
import { getNewFile } from "../../../helpers/getNewFile";

/* Useful Docs */
//doc : https://docs.dropzone.dev/
//doc2: https://react-dropzone-uploader.js.org/

export const Uploader = () => {
  const initValues = {
    errorShowModal: false,
    headMsg: "",
    bodyMsg: "",
  };
  const [token, setToken] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [countFiles, setcountFiles] = useState(0);
  const [imageArray, setImageArray] = useState([]);
  const [videoArray, setVideoArray] = useState([]);
  const [values, setValues] = useState(initValues);
  const { errorShowModal, headMsg, bodyMsg } = values;
  const [countVideos, setcountVideos] = useState(0);
  useEffect(() => {
    if (!token) {
      signIn()
        .then((value) => setToken(value))
        .catch((error) => console.log("error", error));
    }
  }, [token]);

  const handleSuccessfulUpload = ()=>{
    //Hide Add Files & Submit Button
    let getButton = document.getElementsByClassName("dzu-submitButton");
    let submitButton = getButton ? getButton[0] : null;
    submitButton.style.display = "none";

    let addFilesClass = document.getElementsByClassName("dzu-inputLabelWithFiles");
    let addFilesButton = addFilesClass ? addFilesClass[0] : null;
    addFilesButton.style.display = "none";
  }

  const handleChangeStatus = async ({ meta, remove }, status) => {
    let isVideo = await getExtensionVideoFile(meta.name);
    switch (status) {
      case "done":
        setcountFiles(countFiles + 1);
        if (isVideo) {
          setcountVideos(countVideos + 1);
        }
        break;
      case "removed":
        setcountFiles(countFiles - 1);
        if (isVideo) {
          setcountVideos(countVideos - 1);
        }
        break;
      default:
        break;
    }

    let getButton = document.getElementsByClassName("dzu-submitButton");
    let submitButton = getButton ? getButton[0] : null;
    let changed = submitButton ? (submitButton.type = "button") : null;
  };
  const getUrl = async (token, fileName, fileType, file) => {
    const answer = await presignedURL(token, fileName, fileType)
      .then((response) => response)
      .catch((error) => false);
    if (answer === false || answer === undefined) {
      showModal(
        true,
        "Warning",
        "Something Wrong Happen with your Multimedia Files <br/> Please Reload the page and try again"
      );
      return;
    } else {
      showModal(
        true,
        "Uploading",
        ` 
        <div class='uploading-div'style="text-align: center">
        <img src="${LoadingGif}" alt="Loader"/> <br />
          <h4>Gathering Your Flower Multimedia Files</h4>
          <i>"super flower powers activate"</i>
        </div>
        `
      );
      const answer2 = await uploadImage(answer, file, fileType)
        .then((response) => response)
        .catch((error) => false);
      return answer2;
    }
  };

  const showModal = (show, header, body) => {
    setValues({
      ...values,
      errorShowModal: show,
      headMsg: header,
      bodyMsg: body,
    });
  };

  const handleSubmitDropzone = async (files) => {
    let titleStory = document.getElementById("storyTitle").value;
    let orderID = document.getElementById("orderId").value;
    let filesUploaded = 0;
    if (countVideos <= 3) {
      for (let index = 0; index < files.length; index++) {
        const { newFileName, fileType, newFile, isVideoFile } =
          await getNewFile(files[index], titleStory, orderID);
        if (isVideoFile) {
          setVideoArray((oldArray) => [...oldArray, newFileName]);
        } else {
          setImageArray((oldArray) => [...oldArray, newFileName]);
        }
        //const uploadedFile = await getUrl(token, newFileName, fileType, files[index].file); BackUp of Original File
        const uploadedFile = await getUrl(
          token,
          newFileName,
          fileType,
          newFile
        );
        uploadedFile ? filesUploaded++ : filesUploaded--;
      }
      if (countFiles === filesUploaded) {
        showModal(
          true,
          "Uploaded",
          "All your multimedia files were successfully uploaded"
        );
      } else {
        showModal(
          true,
          "Warning",
          `Something Wrong Happen with your Multimedia Files <br/> Uploaded ${filesUploaded}/${countFiles} <br/> Please Reload the page and try again`
        );
      }
      handleSuccessfulUpload();
      setSubmitted(true);
    } else {
      showModal(
        true,
        "Warning",
        "Only one video is allowed <br/> Please remove the other video file and try again"
      );
      return;
    }
  };

  return (
    <>
      <Dropzone
        onChangeStatus={handleChangeStatus}
        onSubmit={handleSubmitDropzone}
        multiple={true}
        canCancel={true}
        maxSizeBytes={process.env.REACT_APP_DROPZONE_MAX_SIZE} //value it's on bytes
        accept="image/*,video/*"
        inputContent={(files, extra) =>
          extra.reject
            ? "Image & Videos files only"
            : "Drop Your Media Files Here"
        }
        styles={{
          dropzone: { height: 200,marginTop:'30px',borderRadius:'0px' },
          dropzoneActive: { borderColor: "green" },
          dropzoneReject: { borderColor: "red", backgroundColor: "#DAA" },
          inputLabel: (files, extra) => (extra.reject ? { color: "red" } : {}),
        }}
        disabled={submitted}
        canRemove={!submitted}
      />
      <input
        type="hidden"
        name="dropSubmit"
        id="dropSubmit"
        value={submitted}
      />
      <input
        type="hidden"
        name="imageArray"
        id="imageArray"
        value={imageArray}
      />
      <input
        type="hidden"
        name="videoArray"
        id="videoArray"
        value={videoArray}
      />
      <ModalAlert
        key={"ModalUploader"}
        errorGet={errorShowModal}
        msgHead={headMsg}
        msgBody={bodyMsg}
      />
    </>
  );
};

export default Uploader;
